import p1_1 from "./p1-1.jpg";
import p1_2 from "./p1-2.jpg";
import p1_3 from "./p1-3.jpg";
import p1_4 from "./p1-4.jpg";
import p1_5 from "./p1-5.jpg";
import p1_6 from "./p1-6.jpg";
import p1_7 from "./p1-7.jpg";
import p1_8 from "./p1-8.jpg";
import p1_9 from "./p1-9.jpg";
import p1_10 from "./p1-10.jpg";
import p1_11 from "./p1-11.jpg";
import p1_12 from "./p1-12.jpg";
import p1_13 from "./p1-13.jpg";
import p1_14 from "./p1-14.jpg";
import p1_15 from "./p1-15.jpg";
import p1_16 from "./p1-16.jpg";
import p1_17 from "./p1-17.jpg";
import p1_18 from "./p1-18.jpg";
import p1_19 from "./p1-19.jpg";
import p1_20 from "./p1-20.jpg";
import p1_21 from "./p1-21.jpg";
import p1_22 from "./p1-22.jpg";
import p1_23 from "./p1-23.jpg";
import p1_24 from "./p1-24.jpg";
import p1_25 from "./p1-25.jpg";
import p1_26 from "./p1-26.jpg";
import p1_27 from "./p1-27.jpg";
import p1_28 from "./p1-28.jpg";
import p1Fp1np3d from "./p1-fp-1np-3d.jpg";
import p1Fp1np2d from "./p1-fp-1np-2d.jpg";
import p1Fp2np3d from "./p1-fp-2np-3d.jpg";
import p1Fp2np2d from "./p1-fp-2np-2d.jpg";

export const pozden1Images = [
  p1_1, p1_2, p1_3, p1_4, p1_5, p1_6, p1_7, p1_8, p1_9, p1_10,
  p1_11, p1_12, p1_13, p1_14, p1_15, p1_16, p1_17, p1_18, p1_19, p1_20,
  p1_21, p1_22, p1_23, p1_24, p1_25, p1_26, p1_27, p1_28,
];

export const pozden1FloorPlans = [
  { image: p1Fp1np3d, label: "1. NP – 3D" },
  { image: p1Fp1np2d, label: "1. NP – 2D" },
  { image: p1Fp2np3d, label: "2. NP – 3D" },
  { image: p1Fp2np2d, label: "2. NP – 2D" },
];
